import styled, { css } from 'styled-components';
import { Button as ANTDButton, Tooltip as ANTDTooltip } from "antd";

export const Tooltip = styled(ANTDTooltip)`
    
`;

export const Button = styled(ANTDButton)`
    ${props => props.iconType == "delete" && css`
        &:hover{
            color: #ff253a;
            border-color: #ff253a;
        }
    `};
`;